import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Row } from "reactstrap";
import { countryPhoneCodes } from "utils/PhoneCodes";
import styles from "./style.module.scss";
import cx from "classnames";

const PhonetInput = (props) => {
  const { id, name = "phone", value, onChange, inputErrors = false } = props
  const [inputData, setInputsData] = useState({});

  useEffect(() => {
    if (value) {
      preloadPhoneInfo(value);
    }
  }, [value]);

  const preloadPhoneInfo = (value) => {
    setInputsData(value);
  }

  const updateValue = (fieldName, value) => {
    const newPhone = {
      ...inputData,
      [fieldName]: value
    };

    // if there is no phone selected 506 by default
    if (!(newPhone[`${name}_cd`]) && fieldName == name) {
      newPhone[`${name}_cd`] = "506"
    }
    setInputsData(newPhone)
    triggerOnChange(newPhone);
  }

  const triggerOnChange = (value) => {
    if (onChange) {
      onChange(value, "phone");
    }
  }

  return (
    <>
      <div className={cx(
        {
          "is-invalid form-control": inputErrors,
          [styles.errorPadding]: inputErrors,
        }
      )}>
        <Row className="g-0">
          <Col xs="4">
            <Input
              id={`${id}_cd`}
              className={styles.countryCode}
              type="select"
              value={inputData[`${name}_cd`] || ''}
              onChange={(e) => updateValue(`${name}_cd`, e.target.value)}
            >
              {countryPhoneCodes.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </Input>
          </Col>
          <Col xs="8">
            <Input
              id={id}
              className={styles.phoneNumber}
              maxLength={8}
              minLength={0}
              type="tel"
              placeholder="Número de teléfono"
              value={inputData[name] || ''}
              onChange={(e) => updateValue(name, e.target.value)}
            />
          </Col>
        </Row>
      </div >
      {inputErrors}
    </>
  );
}

export default PhonetInput;